import React, { useState, useEffect } from 'react';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';


// Custom SVG icons — handcrafted
const UserIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const BellIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

const ShieldIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const LogOutIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

const SaveIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
    <polyline points="17 21 17 13 7 13 7 21" />
    <polyline points="7 3 7 8 15 8" />
  </svg>
);

const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="square">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const TrashIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <path d="M10 11v6" /><path d="M14 11v6" />
  </svg>
);

const AlertIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

const InfoIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

const LinkIcon = () => (
  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

// Editorial block header
const BlockHeader = ({ Icon, title, subtitle, accent = '#4A90E2', number }) => (
  <div style={{ marginBottom: '24px' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '0', marginBottom: subtitle ? '6px' : 0 }}>
      {/* Accent block with icon */}
      <div style={{
        background: accent,
        width: '36px', height: '36px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: '#0A0C10',
        flexShrink: 0,
        clipPath: 'polygon(0 0, calc(100% - 6px) 0, 100% 6px, 100% 100%, 0 100%)'
      }}><Icon /></div>
      <div style={{
        flex: 1,
        height: '2px',
        background: `linear-gradient(90deg, ${accent} 0%, rgba(74,144,226,0.05) 100%)`
      }} />
      <span style={{
        fontFamily: 'Impact, Haettenschweiler, sans-serif',
        fontSize: '1.125rem',
        fontWeight: 900,
        color: '#EEF0F2',
        letterSpacing: '-0.01em',
        textTransform: 'uppercase',
        marginLeft: '14px'
      }}>{title}</span>
    </div>
    {subtitle && (
      <p style={{
        fontFamily: 'Georgia, serif',
        fontStyle: 'italic',
        fontSize: '0.8125rem',
        color: '#8A95A3',
        marginLeft: '50px',
        marginTop: '4px'
      }}>{subtitle}</p>
    )}
  </div>
);

const DeleteAccountModal = ({ isOpen, onClose, onConfirm, isDeleting }) => {
  const [confirmText, setConfirmText] = useState('');
  if (!isOpen) return null;
  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(0,0,0,0.9)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '24px'
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#111318',
          border: '1px solid rgba(232,85,85,0.3)',
          borderTop: '4px solid #E85555',
          maxWidth: '440px', width: '100%',
          padding: '32px',
          boxShadow: '8px 8px 0 rgba(232,85,85,0.1), 0 24px 80px rgba(0,0,0,0.8)'
        }}
        onClick={e => e?.stopPropagation()}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '20px' }}>
          <div style={{
            width: '44px', height: '44px',
            background: 'rgba(232,85,85,0.1)',
            border: '2px solid rgba(232,85,85,0.3)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#E85555',
            flexShrink: 0
          }}><AlertIcon /></div>
          <div>
            <h3 style={{
              fontFamily: 'Impact, Haettenschweiler, sans-serif',
              fontSize: '1.25rem',
              fontWeight: 900,
              color: '#EEF0F2',
              letterSpacing: '-0.01em',
              textTransform: 'uppercase',
              margin: 0
            }}>Slett konto</h3>
            <p style={{
              fontFamily: 'Georgia, serif',
              fontStyle: 'italic',
              fontSize: '0.8125rem',
              color: '#8A95A3',
              margin: 0
            }}>Denne handlingen kan ikke angres</p>
          </div>
        </div>
        <div style={{
          background: 'rgba(232,85,85,0.06)',
          borderLeft: '3px solid #E85555',
          padding: '14px 16px',
          marginBottom: '20px'
        }}>
          <p style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '0.8125rem',
            color: '#EEF0F2',
            lineHeight: 1.6,
            margin: 0
          }}>
            Alle dine data, kjøretøy, fakturaer og abonnementshistorikk vil bli{' '}
            <strong style={{ color: '#E85555' }}>permanent slettet</strong>.
          </p>
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label style={{
            fontFamily: 'Syne, sans-serif',
            fontSize: '0.6875rem',
            fontWeight: 800,
            color: '#8A95A3',
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            display: 'block',
            marginBottom: '8px'
          }}>Skriv <strong style={{ color: '#E85555' }}>SLETT</strong> for å bekrefte</label>
          <input
            type="text"
            value={confirmText}
            onChange={e => setConfirmText(e?.target?.value)}
            placeholder="SLETT"
            style={{
              width: '100%', padding: '10px 14px',
              background: 'rgba(15,17,23,0.8)',
              border: `2px solid ${confirmText === 'SLETT' ? '#E85555' : 'rgba(138,149,163,0.2)'}`,
              color: '#EEF0F2',
              fontFamily: 'JetBrains Mono, "Courier New", monospace',
              fontSize: '0.875rem',
              outline: 'none',
              boxSizing: 'border-box',
              transition: 'border-color 200ms ease'
            }}
          />
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={() => { if (confirmText === 'SLETT') onConfirm(); }}
            disabled={confirmText !== 'SLETT' || isDeleting}
            style={{
              flex: 1, padding: '12px 20px',
              background: confirmText === 'SLETT' ? '#E85555' : 'rgba(232,85,85,0.08)',
              border: '1px solid rgba(232,85,85,0.3)',
              color: confirmText === 'SLETT' ? '#fff' : '#8A95A3',
              fontFamily: 'Syne, sans-serif',
              fontSize: '0.75rem',
              fontWeight: 800,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              cursor: confirmText === 'SLETT' && !isDeleting ? 'pointer' : 'not-allowed',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
              transition: 'all 200ms ease',
              boxShadow: confirmText === 'SLETT' ? '3px 3px 0 rgba(232,85,85,0.3)' : 'none'
            }}
          >
            <TrashIcon />
            {isDeleting ? 'Sletter...' : 'Slett konto permanent'}
          </button>
          <button
            onClick={onClose}
            style={{
              padding: '12px 20px',
              background: 'transparent',
              border: '1px solid rgba(138,149,163,0.2)',
              color: '#8A95A3',
              fontFamily: 'Inter, sans-serif',
              fontSize: '0.875rem',
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'all 200ms ease'
            }}
            onMouseEnter={e => { e.currentTarget.style.color = '#EEF0F2'; e.currentTarget.style.borderColor = 'rgba(138,149,163,0.4)'; }}
            onMouseLeave={e => { e.currentTarget.style.color = '#8A95A3'; e.currentTarget.style.borderColor = 'rgba(138,149,163,0.2)'; }}
          >Avbryt</button>
        </div>
      </div>
    </div>
  );
};

const AccountSettingsSection = ({ accountData, onSave, signOut }) => {
  const [formData, setFormData] = useState(accountData);
  const [isSaving, setIsSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  useEffect(() => { setFormData(accountData); }, [accountData?.email]);

  const handleInputChange = (field, value) => setFormData(prev => ({ ...prev, [field]: value }));
  const handleNotificationChange = (field, checked) => setFormData(prev => ({ ...prev, notifications: { ...prev?.notifications, [field]: checked } }));
  const handlePrivacyChange = (field, checked) => setFormData(prev => ({ ...prev, privacy: { ...prev?.privacy, [field]: checked } }));

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setIsSaving(true);
    await onSave(formData);
    setTimeout(() => { setIsSaving(false); setSaved(true); setTimeout(() => setSaved(false), 2500); }, 500);
  };

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try { await signOut?.(); } finally { setIsLoggingOut(false); }
  };

  const handleDeleteAccount = async () => {
    setIsDeleting(true);
    try { await signOut?.(); } finally { setIsDeleting(false); setIsDeleteModalOpen(false); }
  };

  return (
    <>
      <DeleteAccountModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleDeleteAccount}
        isDeleting={isDeleting}
      />

      <div style={{
        background: '#111318',
        border: '1px solid rgba(255,255,255,0.06)',
        borderTop: '3px solid #6B5CE7',
        overflow: 'hidden'
      }}>

        {/* Editorial header */}
        <div style={{
          background: 'rgba(107,92,231,0.06)',
          padding: '24px 32px',
          borderBottom: '1px solid rgba(107,92,231,0.15)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '16px',
          flexWrap: 'wrap'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            {/* Icon block */}
            <div style={{
              width: '44px', height: '44px',
              background: '#6B5CE7',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: '#fff',
              clipPath: 'polygon(0 0, calc(100% - 8px) 0, 100% 8px, 100% 100%, 0 100%)'
            }}><UserIcon /></div>
            <div>
              <h2 style={{
                fontFamily: 'Impact, Haettenschweiler, sans-serif',
                fontSize: '1.375rem',
                fontWeight: 900,
                color: '#EEF0F2',
                letterSpacing: '-0.01em',
                textTransform: 'uppercase',
                margin: 0,
                lineHeight: 1
              }}>Kontoinnstillinger</h2>
              <p style={{
                fontFamily: 'Georgia, serif',
                fontStyle: 'italic',
                fontSize: '0.8125rem',
                color: '#8A95A3',
                margin: '3px 0 0'
              }}>Personlig informasjon og preferanser</p>
            </div>
          </div>

          {/* Logout button */}
          <button
            type="button"
            onClick={handleLogout}
            disabled={isLoggingOut}
            style={{
              display: 'flex', alignItems: 'center', gap: '8px',
              padding: '10px 20px',
              background: 'transparent',
              border: '1px solid rgba(245,166,35,0.3)',
              color: '#F5A623',
              fontFamily: 'Syne, sans-serif',
              fontSize: '0.6875rem',
              fontWeight: 800,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              cursor: isLoggingOut ? 'not-allowed' : 'pointer',
              opacity: isLoggingOut ? 0.7 : 1,
              transition: 'all 200ms ease'
            }}
            onMouseEnter={e => { if (!isLoggingOut) { e.currentTarget.style.background = 'rgba(245,166,35,0.1)'; e.currentTarget.style.borderColor = 'rgba(245,166,35,0.6)'; } }}
            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.borderColor = 'rgba(245,166,35,0.3)'; }}
          >
            <LogOutIcon />
            {isLoggingOut ? 'Logger ut...' : 'Logg ut'}
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Personal info */}
          <div style={{ padding: '32px 32px 0' }}>
            <BlockHeader Icon={UserIcon} title="Personlig informasjon" accent="#4A90E2" />
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '16px' }}>
              <Input label="Fornavn" type="text" value={formData?.firstName} onChange={(e) => handleInputChange('firstName', e?.target?.value)} required />
              <Input label="Etternavn" type="text" value={formData?.lastName} onChange={(e) => handleInputChange('lastName', e?.target?.value)} required />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
              <Input label="E-postadresse" type="email" value={formData?.email} onChange={(e) => handleInputChange('email', e?.target?.value)} description="Brukes til faktura og viktige varsler" required />
              <Input label="Telefonnummer" type="tel" value={formData?.phone} onChange={(e) => handleInputChange('phone', e?.target?.value)} placeholder="+47 XXX XX XXX" />
            </div>
          </div>

          {/* Handcrafted dashed divider */}
          <div style={{ margin: '28px 32px', height: '1px', background: 'repeating-linear-gradient(90deg, rgba(74,144,226,0.2) 0px, rgba(74,144,226,0.2) 6px, transparent 6px, transparent 14px)' }} />

          {/* Notifications */}
          <div style={{ padding: '0 32px' }}>
            <BlockHeader Icon={BellIcon} title="Varslingsinnstillinger" subtitle="Velg hvordan du vil motta oppdateringer" accent="#6B5CE7" />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {[
                { field: 'email',   label: 'E-postvarsler',  desc: 'Motta fakturaer og viktige oppdateringer via e-post', checked: formData?.notifications?.email },
                { field: 'sms',     label: 'SMS-varsler',     desc: 'Få SMS om bompasseringer og betalinger',              checked: formData?.notifications?.sms },
                { field: 'traffic', label: 'Trafikkvarsler',  desc: 'Varsler om trafikkforstyrrelser på dine ruter',       checked: formData?.notifications?.traffic },
              ]?.map(item => (
                <div key={item?.field} style={{
                  padding: '14px 16px',
                  background: item?.checked ? 'rgba(107,92,231,0.06)' : 'rgba(255,255,255,0.02)',
                  borderLeft: item?.checked ? '3px solid #6B5CE7' : '3px solid transparent',
                  transition: 'all 200ms ease'
                }}>
                  <Checkbox label={item?.label} description={item?.desc} checked={item?.checked} onChange={(e) => handleNotificationChange(item?.field, e?.target?.checked)} />
                </div>
              ))}
            </div>
          </div>

          <div style={{ margin: '28px 32px', height: '1px', background: 'repeating-linear-gradient(90deg, rgba(46,196,160,0.2) 0px, rgba(46,196,160,0.2) 6px, transparent 6px, transparent 14px)' }} />

          {/* Privacy */}
          <div style={{ padding: '0 32px' }}>
            <BlockHeader Icon={ShieldIcon} title="Personvern og GDPR" subtitle="Administrer dine personverninnstillinger" accent="#2EC4A0" />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '20px' }}>
              {[
                { field: 'dataProcessing', label: 'Databehandlingssamtykke', desc: 'Jeg samtykker til behandling av mine personopplysninger i henhold til GDPR', checked: formData?.privacy?.dataProcessing, required: true },
                { field: 'marketing',      label: 'Markedsføring',           desc: 'Motta tilbud og nyheter om NordPass-tjenester',                            checked: formData?.privacy?.marketing },
                { field: 'dataSharing',    label: 'Datadeling med partnere', desc: 'Tillat deling av anonymiserte data med veimyndigheter for bedre tjenester', checked: formData?.privacy?.dataSharing },
              ]?.map(item => (
                <div key={item?.field} style={{
                  padding: '14px 16px',
                  background: item?.checked ? 'rgba(46,196,160,0.05)' : 'rgba(255,255,255,0.02)',
                  borderLeft: item?.checked ? '3px solid #2EC4A0' : '3px solid transparent',
                  transition: 'all 200ms ease'
                }}>
                  <Checkbox label={item?.label} description={item?.desc} checked={item?.checked} onChange={(e) => handlePrivacyChange(item?.field, e?.target?.checked)} required={item?.required} />
                </div>
              ))}
            </div>

            {/* GDPR info block */}
            <div style={{
              display: 'flex', alignItems: 'flex-start', gap: '12px',
              padding: '16px 18px',
              background: 'rgba(46,196,160,0.04)',
              borderLeft: '3px solid #2EC4A0',
              marginBottom: '32px'
            }}>
              <div style={{ color: '#2EC4A0', flexShrink: 0, marginTop: '1px' }}><InfoIcon /></div>
              <div>
                <p style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.8125rem', fontWeight: 700, color: '#EEF0F2', marginBottom: '4px', letterSpacing: '-0.01em' }}>GDPR-rettigheter</p>
                <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: '#8A95A3', lineHeight: 1.6 }}>
                  Du har rett til å be om innsyn, retting eller sletting av dine personopplysninger når som helst.
                </p>
                <button type="button" style={{
                  fontFamily: 'Inter, sans-serif', fontSize: '0.75rem',
                  color: '#2EC4A0', fontWeight: 500,
                  background: 'none', border: 'none',
                  cursor: 'pointer', padding: 0,
                  marginTop: '8px',
                  display: 'flex', alignItems: 'center', gap: '5px'
                }}>
                  Les personvernerklæring <LinkIcon />
                </button>
              </div>
            </div>
          </div>

          {/* Submit row */}
          <div style={{
            padding: '20px 32px',
            borderTop: '1px solid rgba(255,255,255,0.05)',
            background: 'rgba(15,17,23,0.5)',
            display: 'flex', gap: '12px', flexWrap: 'wrap'
          }}>
            <button
              type="submit"
              disabled={isSaving}
              style={{
                background: saved ? 'rgba(46,196,160,0.1)' : '#F5A623',
                color: saved ? '#2EC4A0' : '#0A0C10',
                padding: '13px 28px',
                border: saved ? '1px solid rgba(46,196,160,0.3)' : 'none',
                cursor: isSaving ? 'not-allowed' : 'pointer',
                opacity: isSaving ? 0.7 : 1,
                display: 'flex', alignItems: 'center', gap: '8px',
                fontFamily: 'Syne, sans-serif',
                fontSize: '0.75rem',
                fontWeight: 800,
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                boxShadow: saved ? 'none' : '3px 3px 0 rgba(245,166,35,0.25)',
                transition: 'all 200ms ease',
                clipPath: saved ? 'none' : 'polygon(0 0, calc(100% - 6px) 0, 100% 6px, 100% 100%, 0 100%)'
              }}
              onMouseEnter={e => { if (!isSaving && !saved) { e.currentTarget.style.transform = 'translate(-1px,-1px)'; e.currentTarget.style.boxShadow = '4px 4px 0 rgba(245,166,35,0.35)'; } }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translate(0,0)'; e.currentTarget.style.boxShadow = saved ? 'none' : '3px 3px 0 rgba(245,166,35,0.25)'; }}
            >
              {saved ? <CheckIcon /> : <SaveIcon />}
              {saved ? 'Lagret!' : isSaving ? 'Lagrer...' : 'Lagre endringer'}
            </button>
            <button
              type="button"
              style={{
                background: 'transparent', color: '#8A95A3',
                padding: '13px 24px',
                border: '1px solid rgba(138,149,163,0.15)',
                cursor: 'pointer',
                fontFamily: 'Inter, sans-serif', fontSize: '0.875rem', fontWeight: 500,
                transition: 'all 200ms ease'
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(138,149,163,0.35)'; e.currentTarget.style.color = '#EEF0F2'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(138,149,163,0.15)'; e.currentTarget.style.color = '#8A95A3'; }}
            >Avbryt</button>
          </div>
        </form>

        {/* Danger zone */}
        <div style={{
          margin: '0 32px 32px',
          padding: '20px 24px',
          background: 'rgba(232,85,85,0.04)',
          border: '1px solid rgba(232,85,85,0.15)',
          borderLeft: '4px solid #E85555'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
            <div>
              <p style={{
                fontFamily: 'Impact, Haettenschweiler, sans-serif',
                fontSize: '1rem',
                fontWeight: 900,
                color: '#E85555',
                letterSpacing: '0.02em',
                textTransform: 'uppercase',
                margin: '0 0 4px'
              }}>Faresone</p>
              <p style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: '0.8125rem', color: '#8A95A3', margin: 0 }}>Permanent sletting av konto og alle tilknyttede data</p>
            </div>
            <button
              type="button"
              onClick={() => setIsDeleteModalOpen(true)}
              style={{
                display: 'flex', alignItems: 'center', gap: '8px',
                padding: '10px 18px',
                background: 'transparent',
                border: '1px solid rgba(232,85,85,0.3)',
                color: '#E85555',
                fontFamily: 'Syne, sans-serif',
                fontSize: '0.6875rem',
                fontWeight: 800,
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                cursor: 'pointer',
                transition: 'all 200ms ease'
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(232,85,85,0.1)'; e.currentTarget.style.borderColor = 'rgba(232,85,85,0.6)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.borderColor = 'rgba(232,85,85,0.3)'; }}
            >
              <TrashIcon />
              Slett konto
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountSettingsSection;